module.exports = __webpack_public_path__ + "media/images/products/placeholder-400x400-67c914b6b064ad24cd7feadce50007a9.png";